import {Component} from "react";
import "../App.css"
class Footer extends Component {
    render() {
        return (
            <div className={'Footer-Wrapper'}>
                <div className={'Footer-Div'}>
                    <ul className={'FooterContent-Container'}>
                        <li className={"Footer-Content"}><p className={'footerFont'}>Organizing Committee: Olga Kocharovskaya, Barnabas Kim, Virgil Sanders, Marlan O.Scully and Matthew Scully. </p> </li>
                        <li className={'Footer-Content'}><p className={'footerFont'}>Please direct inquiries to the following addresses: </p> </li>

                        <li className={'Footer-Content'}> <p className={'footerFont'}>
                            For inquiries about the website, abstracts, including selection of best abstract: Matthew Scully, &nbsp;<strong>Mattscully@pqeconference.com</strong>
                        </p></li>
                        <li className={'Footer-Content'}> <p className={'footerFont'}>
                            Payments and registration: Marlan Scully, &nbsp; <strong>Scully@tamu.edu</strong>
                        </p></li>
                        <li className={'Footer-Content'}> <p className={'footerFont'}>
                            Regarding the program: Olga Kocharovskaya, &nbsp; <strong>Kochar@physics.tamu.edu</strong>
                        </p></li>
                        <li className={'Footer-Content'}> <p className={'footerFont'}>
                            For scheduling: Virgil Sanders, &nbsp; <strong>Virgil.Sanders@gmail.com</strong>
                        </p></li>
                    </ul>
                </div>
            </div>
        );
    }
}


export default Footer